import { Controller } from "@hotwired/stimulus"

// Handles search field icon toggling and clear functionality
// Usage:
//   <div data-controller="search-field" data-action="input->search-field#toggleIcons">
//     <input data-search-field-target="input">
//     <a data-search-field-target="clearButton" data-action="click->search-field#clear"></a>
//     <div data-search-field-target="searchIcon"></div>
//   </div>
export default class extends Controller {
  static targets = ["input", "clearButton", "searchIcon"]

  connect() {
    this.toggleIcons()
  }

  toggleIcons() {
    const hasValue = this.inputTarget.value.trim().length > 0

    if (hasValue) {
      this.clearButtonTarget.classList.remove("hidden")
      this.searchIconTarget.classList.add("hidden")
    } else {
      this.clearButtonTarget.classList.add("hidden")
      this.searchIconTarget.classList.remove("hidden")
    }
  }

  clear(event) {
    event.preventDefault()
    this.inputTarget.value = ""
    this.toggleIcons()
    this.inputTarget.focus()
    
    // Trigger input event to potentially auto-submit the form if auto-submit controller is present
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
